export default __webpack_public_path__ + "static/media/Ki.dd31942e.woff";